import { KBarResults, useMatches } from 'kbar'
import { SourceIcon } from './headers/source-icon'
import {
  groupNameStyle,
  resultItemStyle,
  shortcutContainerStyle,
  shortcutKeyStyle,
} from './styles'
import type { ProblemAction } from './types'

export function RenderResults() {
  const { results } = useMatches()

  return (
    <KBarResults
      items={results}
      onRender={({ item, active }) => {
        if (typeof item === 'string') {
          return <div style={groupNameStyle}>{item}</div>
        }

        // Cast to our extended action type to access custom properties
        const action = item as unknown as ProblemAction

        return (
          <div style={resultItemStyle(active)}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                flex: 1,
              }}
            >
              {action.sourceIcon && (
                <SourceIcon
                  sourceIcon={action.sourceIcon}
                  source={action.source}
                />
              )}
              <span style={{ flex: 1 }}>{item.name}</span>
            </div>
            {item.shortcut?.length ? (
              <div style={shortcutContainerStyle}>
                {item.shortcut.map((sc: string) => (
                  <kbd key={sc} style={shortcutKeyStyle}>
                    {sc}
                  </kbd>
                ))}
              </div>
            ) : null}
          </div>
        )
      }}
    />
  )
}
